import { IInternalControlsState } from './types';

const initialInternalControlsState = (): IInternalControlsState => ({
  error: null,
  loading: false,
  drawTable: false,
  selectedEntityId: undefined,
  saveDisabled: true,
  hasChanges: false
});

export default initialInternalControlsState;
